import { ModulesMap } from '@/config/data/modulesMaps'

import DataTransferModule from '@/services/dataTransferModule'

import ClustersApi from '@/services/apiServiceModules/clustersApi'
const clustersApi = new ClustersApi()

export default class ClustersDt extends DataTransferModule {
	constructor() {
		super(ModulesMap.CLUSTERS, clustersApi, {
			useCache: true,
		})
	}
}
